import * as Types from "actions/types";
import axios from "axios";
import {endpoints} from "variables/variables.jsx";

export function getAdminShipmentsPromise(user, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "get",
    url: endpoints.admin+"/shipment/all/",
    headers: { Authorization: `Bearer ${token}` }
  })
  .then(res => {

      var data = res.data.data;

      dispatch(getShipmentsSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getShipmentsFailure(res)));  
}

export function getAdminShipments(user) {

  return (dispatch, failure) => {
    dispatch(getShipments());
    return getAdminShipmentsPromise(user, dispatch);
  };
}

export function getCustomerShipmentsPromise(user, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "get",
    url: endpoints.public+"/shipment/all",
    headers: { Authorization: `Bearer ${token}` }
  })
  .then(res => {

      var data = res.data.data;

      dispatch(getShipmentsSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getShipmentsFailure(res)));  
}

export function getCustomerShipments(user) {

  return (dispatch, failure) => {
    dispatch(getShipments());
    return getCustomerShipmentsPromise(user, dispatch);
  };
}

function getShipments() {
  return {
    type: Types.SHIPMENTS_GET
  };
}

function getShipmentsSuccess(shipments) {   
  return {
    type: Types.SHIPMENTS_GET_SUCCESS,
    shipments
  };
}

function getShipmentsFailure() {
  return {
    type: Types.SHIPMENTS_GET_FAILURE
  }
}


export function postCustomerShipment(user, data) {

  return (dispatch, failure) => {
    dispatch(postShipment());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "post",
      url: endpoints.public+"/shipment",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {     
        dispatch(postShipmentSuccess(user, data));
        return user;
      })
      .catch(() => dispatch(postShipmentFailure()));
  };
}


function postShipment() {
  return {
    type: Types.SHIPMENT_POST
  };
}

function postShipmentSuccess(user, data) {   

  return {
    type: Types.SHIPMENT_POST_SUCCESS,
  };
}

function postShipmentFailure() {
  return {
    type: Types.SHIPMENT_POST_FAILURE
  }
}


export function putCustomerShipment(user, data) {

  return (dispatch, failure) => {
    dispatch(putShipment());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "put",
      url: endpoints.public+"/shipment",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {     
        dispatch(putShipmentSuccess(user, data));
        return user;
      })
      .catch(() => dispatch(putShipmentFailure()));
  };
}


function putShipment() {
  return {
    type: Types.SHIPMENT_PUT
  };
}

function putShipmentSuccess(user, data) {   

  return {
    type: Types.SHIPMENT_PUT_SUCCESS,
  };
}

function putShipmentFailure() {
  return {
    type: Types.SHIPMENT_PUT_FAILURE
  }
}

export function deleteCustomerShipment(user, data) {

  return (dispatch, failure) => {
    dispatch(deleteShipment());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "post",
      url: endpoints.public+"/shipment/delete",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {     
        dispatch(deleteShipmentSuccess(user, data));
        return user;
      })
      .catch(() => dispatch(deleteShipmentFailure()));
  };
}


function deleteShipment() {
  return {
    type: Types.SHIPMENT_DELETE
  };
}

function deleteShipmentSuccess(user, data) {   

  return {
    type: Types.SHIPMENT_DELETE_SUCCESS,
  };
}

function deleteShipmentFailure() {
  return {
    type: Types.SHIPMENT_DELETE_FAILURE
  }
}


export function getReceiverShipmentsPromise(user, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "get",
    url: endpoints.public+"/shipment/receiver",
    headers: { Authorization: `Bearer ${token}` }
  })
  .then(res => {

      var data = res.data.data;

      dispatch(getShipmentsSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getShipmentsFailure(res)));  
}

export function getReceiverShipments(user) {

  return (dispatch, failure) => {
    dispatch(getShipments());
    return getReceiverShipmentsPromise(user, dispatch);
  };
}

export function putReceiverShipment(user, data) {

  return (dispatch, failure) => {
    dispatch(putShipment());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "put",
      url: endpoints.public+"/shipment/receiver",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {     
        dispatch(putShipmentSuccess(user, data));
        return user;
      })
      .catch(() => dispatch(putShipmentFailure()));
  };
}




// WEBPACK FOOTER //
// ./src/actions/shipment.js